import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { SystemManagerService } from '../services/system-manager.service';
import { PBXSettingsRequirements } from './../interfaces/pbx-settings-requirements';

const logContext = 'PBXSettingsManagementGuard';

@Injectable({
  providedIn: 'root'
})
export class PBXSettingsManagementGuard {
  constructor(
    private route: Router,
    private systemManagerService: SystemManagerService
  ) { }

  async canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    try {
      let compatiblePBXType = false;
      const pbxType = next.params.pbx;
      const requiredComponentTypes = PBXSettingsRequirements.find(req => req.pbxType == pbxType)?.requiredComponentTypes ?? [];
      if(pbxType && !!requiredComponentTypes.length) {
        const componentsEmbedded = await this.systemManagerService.getComponents() ?? [];
        // intersect pbxType.requiredComponentTypes and componentsEmbedded list
        // check if the intersection has the same length as the requiredComponentTypes array
        // which means that all the necessary components are found
        compatiblePBXType = !!componentsEmbedded.length && !!requiredComponentTypes.length &&
          requiredComponentTypes.filter(reqApplicationType => !!componentsEmbedded?.find(component =>
            component.componentType == reqApplicationType))?.length == requiredComponentTypes.length;
      }
      if (compatiblePBXType) {
        return Promise.resolve(true);
      }
    } catch (error) {
      console.error(`${logContext}.Error reading components from system manager: `, error);
    }
    
    console.log('Not compatible PBX type - Redirecting to Navigation error page');
    this.route.navigate(['navigationError']);
    return Promise.resolve(false);
  }

}